<template>
  <div style="height: 100vh;position: relative;">
    <div style="text-align: center;padding:300rem 0;font-size:24rem;">
      网站正在建设中...
    </div>
    <div style="width:1920rem; background:#12151A;position: absolute;bottom: 0;">
      <div style="padding:50rem;text-align: center;"><a style="color: white;font-size:18rem;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2021023770号-1</a></div>
    </div>
  </div>
</template>

<script>

export default {
  components: { },
  data() {
    return {
    }
  },

  created() {
    console.log("route", window.location.href)
    document.title = 'caixiaowen.com'
  },

  methods: {
  },
}
</script>

<style scoped>
</style>
